import { Extension } from '@tiptap/core'
import { createMinuteTreePlugin } from './minute-tree-plugin'

export const MinuteTreeExtension = Extension.create({
  name: 'minuteTree',

  addProseMirrorPlugins() {
    return [createMinuteTreePlugin()]
  },
})
